<template>
  <div>
    <generic-table
      ref="datatable"
      :title="$t('status')"
      :columns="columns"
      :column_search="true"
      :extra_buttons="extra_buttons"
      :page_length="25"
      resource_url="/helpdesk/status/datatables"
    ></generic-table>
  </div>

  <status-modal ref="status_modal" @success="refresh" />
</template>

<script>
import GenericTable from "@/components/generic_table/GenericTable.vue";
import {
  generate_datatables_buttons,
  confirm_deletion_dialog,
  del,
  error_message,
} from "@/utils";
import StatusModal from "./status_modal/Index.vue";

export default {
  name: "StatusDatatable",
  components: { GenericTable, StatusModal },
  data() {
    let v = this;
    return {
      extra_buttons: [
        {
          text: v.$t("add_status"),
          icon: "fa fa-plus",
          class: "is-primary is-rounded",
          click: this.create,
        },
      ],
      columns: [
        {
          title: v.$t("name"),
          name: "name",
          searchable: true,
          data: (row) => {
            const colorStyle = row.color
              ? `background-color: ${row.color}; color: white;`
              : "";
            const iconClass = row.is_closed_status
              ? "fa-check-circle"
              : row.is_resolved_status
              ? "fa-check"
              : "fa-clock-o";

            return `<div class="media">
              <div class="media-left">
                <span class="tag" style="${colorStyle}">
                  <i class="fa ${iconClass}"></i>
                </span>
              </div>
              <div class="media-content">
                <div class="content">
                  <p class="title is-6 mb-1">${row.name || ""}</p>
                  <p class="subtitle is-7 has-text-grey">${
                    row.description || ""
                  }</p>
                </div>
              </div>
            </div>`;
          },
        },
        {
          title: v.$t("type"),
          searchable: false,
          data: (row) => {
            if (row.is_closed_status) {
              return `<span class="tag is-dark">${v.$t("closed")}</span>`;
            } else if (row.is_resolved_status) {
              return `<span class="tag is-success">${v.$t("resolved")}</span>`;
            } else {
              return `<span class="tag is-info">${v.$t("in_progress")}</span>`;
            }
          },
        },
        {
          title: v.$t("order"),
          searchable: false,
          data: (row) => {
            return `<span class="tag is-light">${row.sort_order || 0}</span>`;
          },
        },
        {
          title: v.$t("notifications"),
          searchable: false,
          data: (row) => {
            const notifications = [];
            if (row.send_email_notification) notifications.push(v.$t("email"));
            if (row.send_sms_notification) notifications.push(v.$t("sms"));

            return notifications.length > 0
              ? notifications
                  .map((n) => `<span class="tag is-info is-light">${n}</span>`)
                  .join(" ")
              : `<span class="tag is-light">${v.$t("none")}</span>`;
          },
        },
        {
          title: v.$t("status"),
          searchable: false,
          data: (row) => {
            const statusClass = row.is_active ? "is-success" : "is-danger";
            const statusText = row.is_active
              ? v.$t("active")
              : v.$t("inactive");
            return `<span class="tag ${statusClass}">${statusText}</span>`;
          },
        },
        {
          title: v.$t("options"),
          searchable: false,
          data: (row) => {
            return generate_datatables_buttons([
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("edit"),
                icon: "fa fa-edit",
                icon_class: "is-small",
                click: function (e) {
                  v.$refs.status_modal.show_modal(e.detail.uuid);
                },
              },
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("delete"),
                icon: "fa fa-trash",
                icon_class: "is-small has-text-danger",
                click: (e) => {
                  let uuid = e.detail.uuid;
                  confirm_deletion_dialog(
                    v.$t("are_you_sure_delete"),
                    v,
                    () => {
                      del("/helpdesk/status", { uuid: uuid })
                        .then(() => {
                          v.refresh();
                        })
                        .catch((error) => {
                          error_message(error);
                        });
                    }
                  );
                },
              },
            ]);
          },
        },
      ],
    };
  },
  methods: {
    create() {
      let v = this;
      v.$refs.status_modal.show_modal();
    },
    refresh() {
      let v = this;
      v.$refs.datatable.refresh();
    },
  },
  mounted() {
    this.refresh();
  },
};
</script>

<style></style>
